module.exports = __webpack_public_path__ + "img/IT0000100008675.5bdb0694.png";